import { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';
import type { TimelineActionProps } from '../../lib/actions-simulations/factory/ActionFactory';

const ActionPreviewModal = dynamic(() => import('./ActionPreviewModal'), {
  ssr: false,
});

export const ACTION_PREVIEW_EVENT = 'open-action-preview';

export function ActionPreview() {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [action, setAction] = useState<TimelineActionProps | null>(null);

  function onOpenPreview(event: CustomEvent) {
    const { action } = event.detail;

    if (!action || !action.type || !action.params) {
      console.warn('Incorrect preview Action type');
      return;
    }

    setAction(action);
    setIsOpen(true);
  }

  useEffect(() => {
    window.addEventListener(
      ACTION_PREVIEW_EVENT,
      onOpenPreview as EventListener
    );

    return () => {
      window.removeEventListener(
        ACTION_PREVIEW_EVENT,
        onOpenPreview as EventListener
      );
    };
  }, []);

  if (!isOpen) {
    return <></>;
  }

  return (
    <ActionPreviewModal action={action!} onClose={() => setIsOpen(false)} />
  );
}
